import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import SUPostsContent from '../SUPost-contents';
import Meta from '../Meta';
import useOnlineHook from '../../utils/useOnlineHook';
import Thumbprint from '../Thumbprint';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import UserContents from '../UserContents';
import PageTitle from '../PageTitle';

import './style.scss';
import DefaultWidget from '../../Widgets/SU/Default';
import { useMediaQuery } from '@mui/material';

const SUHomepage = ({
    keyword,
    searchBy
}) => {
    useOnlineHook();

    const isMobile = useMediaQuery('(max-width: 899px)');

    const [refetch, setRefetch] = useState(false);
    const [isPu, setIsPu] = useState(false);
    const [userInformation, setUserInformation] = useState({});
    const [showThumbprint, setShowThumbprint] = useState(false);

    useEffect(() => {
        const pathname = window.location.pathname.replace('/');
        if (pathname === userInformation.login) {
            setIsPu(false);
        } else {
            setIsPu(true);
        }

        $.fancybox.defaults.parentEl = '.su-fancybox-container';

        if ($.fancybox.getInstance() !== false) {
            setShowThumbprint(true);
        }

        setUserInformation(JSON.parse(localStorage.getItem('user')));
    }, []);



    return (
        <div className="su-homepage">
            <Meta />

            <Grid2
                container
                spacing={isMobile ? 0 : 2}
            >
                <Grid2
                    className='su-homepage__center'
                    md={8}
                >
                    <PageTitle
                        title='Home'
                        searchable={true}
                    />

                    {
                        !searchBy || searchBy === '' || searchBy === 'post' || keyword.length <= 0
                            ? <React.Fragment>
                                <SUPostsContent refetch={refetch} setRefetch={setRefetch} isPu={isPu} />
                                <div className={'su-fancybox-container'}>
                                    {showThumbprint && <div className={'post-thumbprint-container'} id={'post-thumbprint-container'}><Thumbprint /></div>}
                                </div>
                            </React.Fragment>
                            : null
                    }

                    {
                        searchBy === 'creator' && keyword && keyword.length > 0
                            ? <React.Fragment>
                                <UserContents />
                            </React.Fragment>
                            : null
                    }
                </Grid2>

                {
                    !isMobile
                        ? <Grid2 className='su-homepage__right' md={4}>
                            <DefaultWidget />
                        </Grid2>
                        : null
                }
            </Grid2>
        </div>
    );
};

const mapStateToProps = state => ({
    keyword: state.search.keyword,
    searchBy: state.search.type,
    users: state.search.users,
});

export default connect(mapStateToProps)(SUHomepage);
